<div class="mc-modal__content">
	<div class="mc-modal__icon"></div>
	<div class="mc-modal__title" [innerHTML]="'modals.disabled_link.title' | translate"></div>
</div>
